module.exports = __webpack_public_path__ + "static/media/insturctor7.f41564f8.png";